import React from 'react';
import { Link } from 'react-router-dom';
import { Tag, Space, Popover } from 'antd';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';
import { toISTDate } from '../../../../../apis/constants';

const ListScreenKeys = ({ documentData, MONEY, priceMasking }) => {
  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];
  const record = documentData;

  const createdDate = (
    <div>
      <div className="column-date">
        {toISTDate(record?.created_at).format('DD/MM/YYYY')}
      </div>
      <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
    </div>
  );
  const receivingStatus = (
    <div>
      <div style={{ color: Helpers.getStatusColor(record?.po_receiving_status || 'NOT_RECEIVED').color }}>
        {Helpers.getStatusColor(record?.po_receiving_status || 'NOT_RECEIVED').text?.toUpperCase()}
      </div>
      {record?.closing_status === 'CLOSED' && (
        <div className="po-short-closed-tag">
          Closed
        </div>
      )}
    </div>
  );
  const paymentStatus = (
    <div
      style={{
        color: Helpers.getStatusColor(record?.payment_status).color,
      }}
    >
      {Helpers.getStatusColor(record?.payment_status).text?.toUpperCase()}
    </div>
  );
  const linkedMRs = (
    <div>
      {
        record?.pr_details?.map((row) => (
          <Link key={row?.pr_id} to={`/purchase/purchase-request/view/${row?.pr_id}`} target="_blank">
            {row.pr_number}
          </Link>
        ))
      }
    </div>
  );
  const linkedMRP = (
    <div className="min-width-85">
      {record?.linked_mrps?.slice(0, 2)?.map((item) => (
        <div
          key={item?.mrp_id}
        >
          {/* <span>
                  {item?.mrp_name}
                </span> */}
          <Link to={`/production/planning/v2/view/${item?.mrp_id}`} target="_blank">
            {' '}
            {/* - */}
            {' '}
            {item?.mrp_number}
          </Link>
        </div>
      ))}
      {record?.linked_mrps?.length > 2 && (

        <Popover
          content={(
            <div className="linked-doc__list__wrapper">
              <div className="linked-doc__list-title">
                Linked MRPs
              </div>
              {record?.linked_mrps?.slice(2)?.map((item) => (
                <div
                  key={item?.mrp_id}

                >
                  {/* <span>
                          {item?.mrp_name}
                        </span> */}
                  <Link
                    to={`/production/planning/view/v2/${item?.mrp_id}`}
                    target="_blank"
                    className="linked-doc__list-items"
                  >
                    {' '}
                    {/* - */}
                    {' '}
                    {item?.mrp_number}
                  </Link>
                </div>
              ))}
            </div>
          )}
        >
          <div className="table-subscript" style={{ color: 'grey', cursor: 'pointer' }}>
            {`and ${record.linked_mrps.length - 2} others`}
          </div>
        </Popover>
      )}
    </div>
  );
  const labels = (
    <Space size={[0, 8]} wrap>
      {record?.tags?.map((tag, index) => (
        <Tag
          key={index}
          color={colorArray[index]}
        >
          {tag}
        </Tag>
      ))}
    </Space>
  );

  return [
    {
      label: 'Items',
      value: record?.po_lines_count || '-',
    },
    {
      label: 'Amount (Without Tax)',
      value: (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view amount" /> : MONEY((record?.po_base_price || '0'), record?.org_currency_info?.currency_code),
    },
    {
      label: 'Taxes',
      value: MONEY((record?.po_gst || '0'), record?.org_currency_info?.currency_code),
    },
    {
      label: 'Created Date',
      value: createdDate,
    },
    {
      label: 'Payment Terms',
      value: !record?.payment_terms?.[0]?.due_days ? 'On Delivery' : `${record?.payment_terms?.[0]?.due_days} Days Credit`,
    },
    {
      label: 'Receiving Status',
      value: receivingStatus,
    },
    {
      label: 'Payment Status',
      value: paymentStatus,
    },
    {
      label: 'Labels',
      value: labels || '-',
    },
    {
      label: 'Linked MR',
      value: linkedMRs || '-',
    },
    {
      label: 'Linked MRP',
      value: linkedMRP || '-',
    },
  ];
};

export {
  ListScreenKeys,
};
